
export default {
  name: 'DiskModel',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    leftBtn: {
      type: String,
      default: '',
    },
    rightBtn: {
      type: String,
      default: '',
    },
    padding: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 400,
    },
  },
  methods: {
    handleLeft() {
      this.$emit('handleLeft')
    },
    handleRight() {
      this.$emit('handleRight')
    },
  },
}
